import type {ComposeMessageRequest} from '@prompt-bridge/shared/validations';

import {isEmailHtmlEmpty} from '../../utils/isEmailHtmlEmpty';
import type {AiComposerDraft} from './AiComposerDraft';
import {extractPlaceholderLiterals} from './comparePlaceholderLiterals';

export const canAutoApplyGeneratedDraft = (
  operation: ComposeMessageRequest['operation'],
  draft: AiComposerDraft,
  isHtml: boolean,
  hasSelection: boolean
): boolean =>
  operation === 'generate' &&
  !hasSelection &&
  (isHtml ? isEmailHtmlEmpty(draft.body) : draft.body.trim() === '') &&
  (draft.subject ?? '').trim() === '' &&
  extractPlaceholderLiterals(draft.body).length === 0 &&
  extractPlaceholderLiterals(draft.subject ?? '').length === 0;
